module.exports = __webpack_public_path__ + "img/hk_biei.7b81ac31.png";